<template>
  <div style="position: absolute; left: 0; top: 0; z-index: 1500; width: 100%; background-color: #F1F1F1;">
    <div style="display: flex; align-items: center; width: 100%; min-height: 100vh;" id="cont_main">
          <div class="col-md-4 offset-md-4 col-xs-10 offset-xs-1 box-shadow-2 p-0">
              <div class="card border-grey border-lighten-3 m-0">
                  <div class="card-header no-border">
                      <div class="card-title text-xs-center">
                          <div class="p-1">
                            <img style="max-width: 70%; min-width: 50%;" src="../assets/pictures/me_logo.png" alt="branding logo">
                            <ul class="nav navbar-nav float-xs-right">  
                              <li class="dropdown dropdown-language nav-item">
                                <a id="dropdown-flag" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn dropdown-toggle nav-link">
                                
                                  <i ref="lang_btn" class="flag-icon" :class="$i18n.tc('lang.logo', $i18n.locale )"></i>
                                
                                </a>
                                
                                <div aria-labelledby="dropdown-flag" class="dropdown-menu">
                                  <a class="dropdown-item" :id="lang" v-for="(lang, index) in listLanguages" :key="index" @click="changeLanguage(lang)">
                                    <i class="flag-icon" :class="$i18n.getLocaleMessage(lang).lang.logo"></i> {{ $i18n.getLocaleMessage(lang).lang.title }}
                                  </a>
                                </div>
                              </li>
                            </ul>
                          </div>
                          
                      </div>
                      
                  </div>
                  <div class="card-body collapse in" v-if="!newpass.showBlock">
                      <div class="card-block">
                          <div class="form-horizontal form-simple">

                            <fieldset class="form-group position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.email.$error }">
                                <input type="text" v-model.trim="$v.email.$model" v-on:keyup.enter="sendRecover()" class="form-control form-control-lg input-lg" :placeholder="$t('registr.lbl.email')" required>
                                <div class="form-control-position">
                                    <i class="icon-email"></i>
                                </div>
                                <div class="error" v-if="!$v.email.required">{{$t('errors.required')}}</div>
                                <div class="error" v-if="!$v.email.email">{{$t('errors.email')}}</div>
                            </fieldset>

                            <button type="button" class="btn btn-auth btn-lg btn-block"  @click="sendRecover()">
                              <i class="icon-envelop"></i> {{ $t('titles.recoverPassword') }}
                            </button>                            

                          </div>
                      </div>
                  </div>
                  <div class="card-body collapse in" v-if="newpass.showBlock">
                      <div class="card-block">
                          <div class="form-horizontal form-simple">

                            <fieldset class="form-group position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.newpass.newPass1.$error }">
                                <input type="text" v-model.trim="$v.newpass.newPass1.$model" v-on:keyup.enter="sendRecoverMain()" class="form-control form-control-lg input-lg" :placeholder="$t('profile.table.newPass')" required>
                                <div class="form-control-position">
                                    <i class="icon-email"></i>
                                </div>
                                <div class="error" v-if="!$v.newpass.newPass1.required">{{$t('errors.required')}}</div>
                                <div class="error" v-if="!$v.newpass.newPass1.minLength">{{$t('errors.minLength')}} {{$v.newpass.newPass1.$params.minLength.min}}</div>
                            </fieldset>

                            <fieldset class="form-group position-relative has-icon-left mb-otstup" :class="{ 'form-group--error': $v.newpass.newPass2.$error }">
                                <input type="text" v-model.trim="$v.newpass.newPass2.$model" v-on:keyup.enter="sendRecoverMain()" class="form-control form-control-lg input-lg" :placeholder="$t('profile.table.newPass2')" required>
                                <div class="form-control-position">
                                    <i class="icon-email"></i>
                                </div>
                                <div class="error" v-if="!$v.newpass.newPass2.required">{{$t('errors.required')}}</div>
                                <div class="error" v-if="!$v.newpass.newPass2.minLength">{{$t('errors.minLength')}} {{$v.newpass.newPass2.$params.minLength.min}}</div>
                            </fieldset>

                            <button type="button" class="btn btn-success btn-lg btn-block"  @click="sendRecoverMain()">
                              <i class="icon-envelop"></i> {{$t('profile.buttons.save')}}
                            </button>                            

                          </div>
                      </div>
                  </div>
                  <div class="card-footer">

                    <div class="row">
                      <div class="col-md-12">
                        <fieldset class="form-group position-relative has-icon-left mb-otstup text-md-right">
                          <router-link :to="{ name: 'login'}" class="card-link">
                            <i class="icon-undo"></i> <span class="menu-title">{{ $t('login.lbl.login') }}</span>
                          </router-link>
                        </fieldset>
                      </div>
                    </div>

                  </div>
              </div>
          </div>

      </div>

  </div>
</template>

<script>
import { required, minLength,  email } from 'vuelidate/lib/validators'
    export default {
      name: "Login",
      components: {},
      data() {
          return {
            errors: [],
            submitStatus: null,
            email: null,

            newpass: {
              showBlock: false,
              newPass1: null,
              newPass2: null,
            }
          };
        },
        validations: {
          email:{ required, email },
          newpass:{
            newPass1:{ required, minLength: minLength(6) },
            newPass2:{ required, minLength: minLength(6) },
          },
        },
        methods: {
          sendRecover() {
            let dataRequest = {
                mail: this.email
            };

            this.$v.$touch();

            if (this.$v.$invalid) {
              this.submitStatus = 'ERROR';
            }

            if((this.$v.email.$error != undefined) && (this.$v.email.$error || this.$v.email.$invalid)){
              this.showNotification('custom-error','Error',this.email);
            } else if(!this.$v.email.$error && !this.$v.email.$invalid){
              this.showNotification('custom-success','OK',this.email);
              /*this.makeQuery("/service/registrationUser", {dataRequest: dataRequest})
              .then(result => {
                  this.showNotification('custom-success','Recovering','Check your email' + ' ' + dataRequest.mail);
                  this.$router.push({ name: 'login'});
              })
              .catch(result => {this.showNotification('custom-error','Error',result); });*/
            }

          },
          sendRecoverMain(){
            this.$v.$touch();

            if (this.$v.$invalid) {
              this.submitStatus = 'ERROR';
            }

            if((this.$v.newpass.newPass1.$error != undefined) && this.$v.newpass.newPass1.$error && this.$v.newpass.newPass2.$error){
              this.showNotification('custom-error','Error',this.email);
            } else if(!this.$v.newpass.newPass1.$error && !this.$v.newpass.newPass2.$error ){
              
              if(this.newpass.newPass1 != this.newpass.newPass2){
                this.showNotification('custom-error','Error',this.$t('errors.passComp'));
                return
              }
              
              let dataRequest = {
                passwordNew: this.newpass.newPass1,
                token: this.$route.params.token
              };


              this.showNotification('custom-success','OK',this.newpass.newPass1);
              console.log(dataRequest);

              this.$router.push({ name: 'login'});
              /*this.makeQuery("/service/registrationUser", {dataRequest: dataRequest})
              .then(result => {
                  this.showNotification('custom-success','Recovering',this.$t('titles.saved') );
                  this.$router.push({ name: 'login'});
              })
              .catch(result => {this.showNotification('custom-error','Error',result); });*/
              
            }

          }
         
        },
        computed:{
          listLanguages(){
            let arrLang = [];
            for (let i = 0; i < this.$i18n.availableLocales.length; i++) {
              arrLang[this.$i18n.getLocaleMessage(this.$i18n.availableLocales[i]).lang.id] = this.$i18n.availableLocales[i];
            }
            return arrLang;
          },
        },
        watch:{},
        mounted () {},
        created() {
          //token
          if ((this.$route.params.token != undefined) && (this.$route.params.token != null)){
            //
            this.newpass.showBlock = true;
            this.newpass.newPass1 = null;
            this.newpass.newPass2 = null;
          }
        }
    }
</script>

<style scoped>

#cont_main{
  background-image: url('../assets/pictures/1.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
}

</style>


// WEBPACK FOOTER //
// src/pages/recover-password.vue